<template>
  <v-app-bar 
    app 
    class="secundary5" 
    height="36" 
    justify-space-around 
    :style="{ 
      marginTop: $vuetify.breakpoint.xsOnly ? '104px' : '48px', 
      zIndex: 998 
    }"
  >
    <v-tabs centered class="secundary round">
      <v-tab
        v-for="navBItem of navBItems"
        :key="navBItem.id"
        :to="navBItem.to"
        :disabled="navBItem.disabled"
      >
        <a
          class="primary--text mx-sm-3 mx-md-7 text-body-2 text-md-body-1"
          style="text-transform: none; text-decoration: none; color: inherit"
        >
          {{ navBItem.name }}
          <v-chip
            class="primary3--text secundary text-lowercase px-0 mb-4"
            x-small
            v-if="navBItem.open == false"
          >
            {{ navBItem.alert }}
          </v-chip>
        </a>
      </v-tab>
    </v-tabs>
    <router-view />
  </v-app-bar>
</template>

<script>
export default {
  name: 'MainHeaderPlat',
  props: ['navBItems'],
  data() {
    return {};
  },
};
</script>

<style scoped>
/* Aplicamos el redondeado al contenedor principal */
.round {
  border-radius: 0px 0px 15px 15px !important;
  overflow: hidden !important; /* Recorte total */
}

/* Forzamos a la barra interna a heredar el redondeado y recortar el fondo */
.round :deep(.v-tabs-bar) {
  border-radius: inherit !important;
  background-color: transparent !important; /* Evita que el fondo interno tape la curva */
}

/* Si al hacer clic se ve un flash cuadrado (efecto ripple) */
.round :deep(.v-tab) {
  border-radius: 0px 0px 15px 15px !important;
}

/* Opcional: Si quieres que el v-app-bar no se vea cuadrado detrás */
.v-app-bar.secundary5 {
  /* Si el fondo del app-bar es lo que se ve cuadrado, 
     podemos hacerlo transparente o redondearlo también */
  background-color: rgba(0,0,0,0) !important; 
  box-shadow: none !important;
}
</style>
